import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { MultiSelectButtonGroupComponent } from '../multi-select-button-group/multi-select-button-group.component';
import { DaySelectorFormGroup } from './day-selector-form.type';

export enum Weekdays {
  allowedMonday = 0,
  allowedTuesday = 1,
  allowedWednesday = 2,
  allowedThursday = 3,
  allowedFriday = 4,
  allowedSaturday = 5,
  allowedSunday = 6,
}

@Component({
    selector: 'app-day-selector',
    templateUrl: './day-selector.component.html',
    styleUrls: ['./day-selector.component.scss'],
    imports: [
        ReactiveFormsModule,
        MultiSelectButtonGroupComponent,
        NgClass,
        TranslateModule,
    ]
})
export class DaySelectorComponent implements OnInit {

  @Input() public form: DaySelectorFormGroup;

  public Weekdays = Weekdays;

  constructor() {
  }

  ngOnInit(): void {
  }

  public selectAll() {
    if (!this.form.controls.allowedMonday.disabled) {
      this.form.controls.allowedMonday.setValue(true);
    }
    if (!this.form.controls.allowedTuesday.disabled) {
      this.form.controls.allowedTuesday.setValue(true);
    }
    if (!this.form.controls.allowedWednesday.disabled) {
      this.form.controls.allowedWednesday.setValue(true);
    }
    if (!this.form.controls.allowedThursday.disabled) {
      this.form.controls.allowedThursday.setValue(true);
    }
    if (!this.form.controls.allowedFriday.disabled) {
      this.form.controls.allowedFriday.setValue(true);
    }
    if (!this.form.controls.allowedSaturday.disabled) {
      this.form.controls.allowedSaturday.setValue(true);
    }
    if (!this.form.controls.allowedSunday.disabled) {
      this.form.controls.allowedSunday.setValue(true);
    }
  }

  public selectWeekdays() {
    if (!this.form.controls.allowedMonday.disabled) {
      this.form.controls.allowedMonday.setValue(true);
    }
    if (!this.form.controls.allowedTuesday.disabled) {
      this.form.controls.allowedTuesday.setValue(true);
    }
    if (!this.form.controls.allowedWednesday.disabled) {
      this.form.controls.allowedWednesday.setValue(true);
    }
    if (!this.form.controls.allowedThursday.disabled) {
      this.form.controls.allowedThursday.setValue(true);
    }
    if (!this.form.controls.allowedFriday.disabled) {
      this.form.controls.allowedFriday.setValue(true);
    }
    this.form.controls.allowedSaturday.setValue(false);
    this.form.controls.allowedSunday.setValue(false);
  }

  public selectWeekend() {
    this.form.controls.allowedMonday.setValue(false);
    this.form.controls.allowedTuesday.setValue(false);
    this.form.controls.allowedWednesday.setValue(false);
    this.form.controls.allowedThursday.setValue(false);
    this.form.controls.allowedFriday.setValue(false);
    if (!this.form.controls.allowedSaturday.disabled) {
      this.form.controls.allowedSaturday.setValue(true);
    }
    if (!this.form.controls.allowedSunday.disabled) {
      this.form.controls.allowedSunday.setValue(true);
    }
  }

  public allActive(): boolean {
    return this.form.controls.allowedMonday.value === true &&
      this.form.controls.allowedTuesday.value === true &&
      this.form.controls.allowedWednesday.value === true &&
      this.form.controls.allowedThursday.value === true &&
      this.form.controls.allowedFriday.value === true &&
      this.form.controls.allowedSaturday.value === true &&
      this.form.controls.allowedSunday.value === true;
  }

  public weekdaysActive(): boolean {
    return this.form.controls.allowedMonday.value === true &&
      this.form.controls.allowedTuesday.value === true &&
      this.form.controls.allowedWednesday.value === true &&
      this.form.controls.allowedThursday.value === true &&
      this.form.controls.allowedFriday.value === true &&
      this.form.controls.allowedSaturday.value === false &&
      this.form.controls.allowedSunday.value === false;
  }

  public weekendActive(): boolean {
    return this.form.controls.allowedMonday.value === false &&
      this.form.controls.allowedTuesday.value === false &&
      this.form.controls.allowedWednesday.value === false &&
      this.form.controls.allowedThursday.value === false &&
      this.form.controls.allowedFriday.value === false &&
      this.form.controls.allowedSaturday.value === true &&
      this.form.controls.allowedSunday.value === true;
  }

  public areAllDaysDisabled(): boolean {
    return this.form.controls.allowedMonday.disabled
      && this.form.controls.allowedTuesday.disabled
      && this.form.controls.allowedWednesday.disabled
      && this.form.controls.allowedThursday.disabled
      && this.form.controls.allowedFriday.disabled
      && this.form.controls.allowedSaturday.disabled
      && this.form.controls.allowedSunday.disabled;
  }

  public areWeekdaysDisabled(): boolean {
    return this.form.controls.allowedMonday.disabled
      && this.form.controls.allowedTuesday.disabled
      && this.form.controls.allowedWednesday.disabled
      && this.form.controls.allowedThursday.disabled
      && this.form.controls.allowedFriday.disabled;
  }

  public areWeekendsDisabled(): boolean {
    return this.form.controls.allowedSaturday.disabled && this.form.controls.allowedSunday.disabled;
  }

}
